// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"8fe8750a","404":"21579e6c","750":"bc1a6080","993":"4bcafaa3"}[chunkId] + ".chunk.js";
};